// import {
//   persistQueryClient,
//   persistQueryClientRestore,
//   persistQueryClientSave,
//   persistQueryClientSubscribe,
// } from "@tanstack/react-query-persist-client";
// import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
// import { useQueryClient } from "@tanstack/react-query";
// import { compress, decompress } from "lz-string";
// import { UserDataType } from "../mine/data";
// import { syncLocalForage } from "./LocalForageSync";

// const localStoragePersister = createSyncStoragePersister({
//   // 使用 localStorage
//   storage: window.localStorage,
//   key: `REACT_QUERY_OFFLINE_CACHE_LOCAL`,
//   // 使用 sessionStorage
//   // storage: window.sessionStorage,
//   // key: `REACT_QUERY_OFFLINE_CACHE_SESSION`,
//   // 使用 localForage
//   //   storage: {
//   //     getItem: syncLocalForage.getItem,
//   //     setItem: syncLocalForage.setItem,
//   //     removeItem: syncLocalForage.removeItem,
//   //   },
//   //   key: `REACT_QUERY_OFFLINE_CACHE_LOCALFORAGE`,
//   throttleTime: Infinity,
//   // 使用lz-string之类的库来压缩和解压缩数据
//   serialize: (data) => compress(JSON.stringify(data)),
//   deserialize: (data) => JSON.parse(decompress(data)),
// });

// const LocalForagePersisterComponent = () => {
//   const queryClient = useQueryClient();
//   //   const userDataList = queryClient.getQueryData(["userDataList"]) as unknown as UserDataType[];

//   // 恢复缓存并自动订阅进一步的更改
//   persistQueryClient({
//     queryClient,
//     persister: localStoragePersister,
//     buster: "buildHash",
//     dehydrateOptions: undefined,
//     maxAge: Infinity,
//   });
//   persistQueryClientSave({
//     queryClient,
//     persister: localStoragePersister,
//     buster: "buildHash",
//     dehydrateOptions: undefined,
//   });
//   // 尝试将hydrate先前持久保存的脱水查询/变异缓存从持久器放回到传递的查询客户端的查询缓存
//   persistQueryClientRestore({
//     queryClient,
//     persister: localStoragePersister,
//     buster: "buildHash",
//   });
//   // 当您的 缓存发生变化时运行queryClient, 订阅查询缓存并返回unsubscribe函数
//   persistQueryClientSubscribe({
//     queryClient,
//     persister: localStoragePersister,
//     buster: "",
//     dehydrateOptions: undefined,
//   });

//   return <></>;
// };

// export default LocalForagePersisterComponent;

export default function Mana() {
  return <></>;
}
